var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEllipses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 300,
    viewBox: "0 0 566 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 150,
    rx: 150,
    ry: 150,
    fill: "#00644B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.871 299.863C316.651 299.84 383.752 232.722 383.752 149.931C383.752 67.1405 316.651 0.0225921 233.871 0V299.863Z",
    fill: "#00644B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.746 293.228C434.905 274.323 479.338 217.331 479.338 149.959C479.338 82.5879 434.905 25.5951 373.746 6.69043V293.228Z",
    fill: "#00644B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.177 266.739C521.26 239.256 543.063 197.155 543.063 149.961C543.063 102.767 521.26 60.666 487.177 33.1826V266.739Z",
    fill: "#00644B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.671 218.17C559.142 197.708 565.048 174.524 565.048 149.961C565.048 125.397 559.142 102.213 548.671 81.752V218.17Z",
    fill: "#00644B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEllipses);
export default __webpack_public_path__ + "static/media/contact-ellipses.70d6288729e22b7aad61003c9347831f.svg";
export { ForwardRef as ReactComponent };